import React from 'react';
import { ShimmerCategoryItem } from 'react-shimmer-effects';

const TableShimmer = ({ columns = 5, rows = 10 }) => {
  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <th key={colIndex} style={{ padding: '10px', textAlign: 'left' }}>
                <ShimmerCategoryItem
                  card
                  avatar
                  animation="wave"
                  cardStyles={{ height: '20px', width: '100px' }}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td
                  key={colIndex}
                  style={{
                    padding: '10px',
                    border: '1px solid #f0f0f0',
                    textAlign: 'left',
                  }}
                >
                  <ShimmerCategoryItem
                    card
                    animation="wave"
                    cardStyles={{ height: '20px', width: '80%' }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableShimmer;
